<template>
    <!-- Help Section -->
    <!-- Help + Footer Section -->
    <div class="footer-section">
        <div class="footer-section__help" v-if="currentRoute != 'contact-us'">
            <div class="footer-section__help-title">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.7"/>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                    <circle cx="12" cy="17" r="0.5" fill="currentColor" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                Need Help?
            </div>
            <div class="footer-section__help-links">
                <a href="mailto:support@mywingio.com" class="footer-section__help-row">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                        <polyline points="22,6 12,13 2,6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    support@mywingio.com
                </a>
                <a href="tel:+447349970810" class="footer-section__help-row">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.42 2 2 0 0 1 3.6 1.25h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    +44 7349 970810
                </a>
                <a href="https://www.mywingio.com/how-it-works" target="_blank" rel="noopener noreferrer" class="footer-section__help-row">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.7"/>
                        <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="1.7"/>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="1.7"/>
                    </svg>
                    mywingio.com/how-it-works
                </a>
            </div>
        </div>

        <!-- Dark footer strip -->
        <div class="footer-section__bottom">
            <div class="footer-section__logo">
                <img :src="logo" height="18px" alt="Wingio" style="opacity: 0.8; filter: brightness(0) invert(1);" />
                <span class="footer-section__logo-name">Wingio</span>
            </div>
            <p class="footer-section__copy">© {{ new Date().getFullYear() }} Wingio. All rights reserved.</p>
            <div class="footer-section__links">
                <a href="https://www.mywingio.com/privacy-policy" target="_blank">Privacy Policy</a>
                <span>·</span>
                <a href="https://www.mywingio.com/terms-of-service" target="_blank">Terms</a>
                <span>·</span>
                <a href="https://www.mywingio.com/shipping-warranty" target="_blank">Shipping</a>
            </div>
        </div>
    </div>

    <!-- Bottom Nav -->
    <div class="bottom-nav-container">
        <div class="bottom-nav">
            <a href="javascript:void(0)" class="nav-item" :class="{ 'active': currentRoute === 'Kids Devices' }" @click="navigateAndClose('/kids-device')">
                <DashboardIcon :iconClass="{ 'svg-icon-active': currentRoute === 'Kids Devices' }" />
                <span>Dashboard</span>
            </a>
            <a href="javascript:void(0)" class="nav-item" :class="{ 'active': currentRoute === 'Applications List' || currentRoute === 'Application' }" @click="navigateAndClose('/play-store')">
                <ApplicationsIcon :iconClass="{ 'svg-icon-active': currentRoute === 'Applications List' }" />
                <span>Apps</span>
            </a>
            <a href="javascript:void(0)" class="nav-item" :class="{ 'active': currentRoute === 'requests' }" @click="navigateAndClose('/requests')">
                <AppRequestListIcon :iconClass="{ 'svg-icon-active': currentRoute === 'requests' }" />
                <span>Requests</span>
            </a>
            <a v-if="enableSchedule" href="javascript:void(0)" class="nav-item nav-item-with-badge" :class="{ 'active': currentRoute === 'schedule' }" @click="navigateAndClose('/schedule')">
                <div class="icon-wrapper">
                    <ScheduleIcon :iconClass="{ 'svg-icon-active': currentRoute === 'schedule' }" />
                </div>
                <span>Schedule</span>
            </a>
            <a href="javascript:void(0)" class="nav-item" :class="{ 'active': showMoreMenu }" @click="toggleMoreMenu()">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <circle cx="5" cy="12" r="1.5" :fill="showMoreMenu ? '#6366f1' : '#9ca3af'"/>
                    <circle cx="12" cy="12" r="1.5" :fill="showMoreMenu ? '#6366f1' : '#9ca3af'"/>
                    <circle cx="19" cy="12" r="1.5" :fill="showMoreMenu ? '#6366f1' : '#9ca3af'"/>
                </svg>
                <span>More</span>
            </a>
        </div>
    </div>

    <!-- Overlay -->
    <div class="more-menu-overlay" :class="{ 'show': showMoreMenu }" @click="closeMoreMenu()"></div>

    <!-- More Menu Panel -->
    <div class="more-menu-panel" :class="{ 'show': showMoreMenu }">
        <div class="more-menu-handle"></div>
        <div class="more-menu-header">
            <h5>More</h5>
            <button class="close-btn" @click="closeMoreMenu()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6l12 12" stroke="#374151" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
        </div>
        <div class="more-menu-content">
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'geofence' }" @click="navigateAndClose('/geofence')">
                <div class="menu-icon"><GeofenceIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Location Alerts</div>
                    <div class="menu-subtitle">Manage safe zones & alerts</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'contacts' }" @click="navigateAndClose('/contacts')">
                <div class="menu-icon"><AddressBookIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Manage Contacts</div>
                    <div class="menu-subtitle">Manage secure contacts</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'manage-chrome' }" @click="navigateAndClose('/manage-chrome')">
                <div class="menu-icon"><ChromeIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Manage Chrome</div>
                    <div class="menu-subtitle">Configure allow & block URLs</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'global-settings' }" @click="navigateAndClose('/global-settings')">
                <div class="menu-icon"><SettingIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Settings</div>
                    <div class="menu-subtitle">Device settings & controls</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'timeline' }" @click="navigateAndClose('/timeline')">
                <div class="menu-icon"><ReportIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Timeline</div>
                    <div class="menu-subtitle">Usage history & insights</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'reports' }" @click="navigateAndClose('/reports')">
                <div class="menu-icon"><ReportIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Reports</div>
                    <div class="menu-subtitle">Analytics & summaries</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'device-info' }" @click="navigateAndClose('/device-info')">
                <div class="menu-icon"><DeviceIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Device Info</div>
                    <div class="menu-subtitle">Device details & status</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'refer-and-earn' }" @click="navigateAndClose('/refer-and-earn')">
                <div class="menu-icon"><ReferAndEarnIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Refer & Earn</div>
                    <div class="menu-subtitle">Invite friends & earn rewards</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'browser-logs' }" @click="navigateAndClose('/browser-logs')">
                <div class="menu-icon"><BrowserLogIcons /></div>
                <div class="menu-text">
                    <div class="menu-title">Browser Logs</div>
                    <div class="menu-subtitle">Web browsing history</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>

            <!-- Account section divider -->
            <div class="more-menu-divider">Account</div>

            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'payment-history' }" @click="navigateAndClose('/payment-history')">
                <div class="menu-icon"><PaymentHistoryIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Payment History</div>
                    <div class="menu-subtitle">View past transactions</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'payment-methods' }" @click="navigateAndClose('/payment-methods')">
                <div class="menu-icon"><PaymentMethodIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Payment Methods</div>
                    <div class="menu-subtitle">Manage payment options</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" :class="{ 'active': currentRoute === 'change-password' }" @click="navigateAndClose('/change-password')">
                <div class="menu-icon"><ChangePasswordIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Change Password</div>
                    <div class="menu-subtitle">Update account password</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
            <a href="javascript:void(0)" class="more-menu-item" @click="navigateAndClose('/contact-us')">
                <div class="menu-icon"><NeedHelpIcon /></div>
                <div class="menu-text">
                    <div class="menu-title">Need Help?</div>
                    <div class="menu-subtitle">Contact support</div>
                </div>
                <svg class="menu-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
        </div>
    </div>
</template>

<script>
import KidsService from "../services/KidsService";
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue'
import DashboardIcon from '@/components/icons/DashboardIcon.vue'
import ApplicationsIcon from '@/components/icons/ApplicationsIcon.vue'
import AppRequestListIcon from '@/components/icons/AppRequestListIcon.vue'
import BrowserLogIcons  from '@/components/icons/BrowserLogIcons.vue'
import PaymentHistoryIcon  from '@/components/icons/PaymentHistoryIcon.vue'
import PaymentMethodIcon from '@/components/icons/PaymentMethodIcon.vue'
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import ScheduleIcon from '@/components/icons/ScheduleIcon.vue'
import SettingIcon from '@/components/icons/SettingIcon.vue'
import DeviceIcon from '@/components/icons/DeviceIcon.vue'
import ReferAndEarnIcon from '@/components/icons/ReferAndEarn.vue'  
import AddressBookIcon from '@/components/icons/AddressBookIcon.vue'
import ReportIcon from '@/components/icons/ReportIcon.vue'
import GeofenceIcon from '@/components/icons/GeofenceIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import QrCodeIcon from '@/components/icons/QrCodeIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import ChromeIcon  from '@/components/icons/ChromeIcon.vue'

export default {
    name: 'KidFooter',
    components: {
        ChromeIcon,
        PaymentMethodIcon,
        DashboardIcon,
        ApplicationsIcon,
        AppRequestListIcon,
        ReferAndEarnIcon,
        BrowserLogIcons,
        PaymentHistoryIcon,
        ChangePasswordIcon,
        ThreeLineMenuIcon,
        NotificationBellIcon,
        NeedHelpIcon,
        ScheduleIcon,
        SettingIcon,
        DeviceIcon,
        AddressBookIcon,
        ReportIcon,
        GeofenceIcon
    },
    props: {
        profileId: String,
        serialNumber: String,
        requestCount: {
            type: Number,
            default: 0
        },
        logo: {
            type: String,
            default: "/images/lya-logo.png",
        },
    },
    data() {
        return {
            currentRoute: this.$route.name,
            showMoreMenu: false,
            routerName: this.$route.name,
            enableSchedule: false,
        }
    },
    methods: {
        toggleMoreMenu() {
            this.showMoreMenu = !this.showMoreMenu;
            if (this.showMoreMenu) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        closeMoreMenu() {
            this.showMoreMenu = false;
            document.body.style.overflow = '';
        },
        navigateTo(path) {
            this.$router.push({ 
                path: path, 
                query: { 
                    profileId: this.profileId, 
                    serialNumber: this.serialNumber 
                } 
            });
        },
        navigateAndClose(path) {
            this.closeMoreMenu();
            this.navigateTo(path);
        },
        async unReadNotificationCount() {
            let data = {
                serialNumber: this.serialNumber,
                profileId: this.profileId
            }
            await KidsService.unReadNotificationCount(data)
            .then((response) => {
                this.enableSchedule = response.data.enableSchedule
            }).catch((e) => {
                this.$toast.error(e.response.data.respones_msg);
                if (e.response.data.is_logout == true) {
                    this.$router.push({ path: '/login'})
                }
            });
        },
    },
    watch: {
        '$route.name'(newName) {
            this.currentRoute = newName;
            this.closeMoreMenu();
        }
    },
    beforeMount() {
        this.unReadNotificationCount();
    },
}
</script>

<style scoped>
/* ── Help Card ── */
.help-card {
    background: #fff;
    border-radius: 14px;
    border: 0.5px solid #e5e7eb;
    margin: 8px 0 12px;
    overflow: hidden;
    width: 100%;
    display: block;
}

.help-card__header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 13px 14px 10px;
    border-bottom: 0.5px solid #f3f4f6;
}

.help-card__icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #eff6ff;
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.help-card__title {
    font-size: 14px;
    font-weight: 700;
    color: #111;
    text-decoration: none;
}

.help-card__body {
    padding: 4px 0;
}

.help-card__row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: #374151;
    text-decoration: none;
    border-bottom: 0.5px solid #f9fafb;
}

.help-card__row:last-child {
    border-bottom: none;
}

.help-card__row:active {
    background: #f9fafb;
}

.help-card__row svg {
    flex-shrink: 0;
    color: #6b7280;
}

/* ── Site Footer ── */
.site-footer {
    padding: 16px 14px 100px;
    text-align: center;
}

.site-footer__copy {
    font-size: 12px;
    color: #9ca3af;
    margin: 0 0 6px;
}

.site-footer__links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
}

.site-footer__links a {
    font-size: 12px;
    color: #6b7280;
    text-decoration: none;
}

.site-footer__links a:hover {
    color: #374151;
}

.site-footer__dot {
    color: #d1d5db;
    font-size: 12px;
}

/* ── Bottom Nav ── */
.bottom-nav-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: #fff;
    border-top: 0.5px solid #e5e7eb;
}

.bottom-nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 60px;
    max-width: 600px;
    margin: 0 auto;
}

.nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    text-decoration: none;
    color: #9ca3af;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    gap: 3px;
}

.nav-item span {
    font-size: 10px;
    font-weight: 500;
}

.nav-item.active {
    color: #6366f1;
}

.nav-item.active::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 2.5px;
    background: #6366f1;
    border-radius: 0 0 3px 3px;
}

/* ── Overlay ── */
.more-menu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease, visibility 0.25s ease;
}

.more-menu-overlay.show {
    opacity: 1;
    visibility: visible;
}

/* ── More Menu Panel ── */
.more-menu-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 20px 20px 0 0;
    z-index: 1002;
    transform: translateY(100%);
    transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
    max-height: 82vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.more-menu-panel.show {
    transform: translateY(0);
}

.more-menu-handle {
    width: 36px;
    height: 4px;
    background: #e5e7eb;
    border-radius: 999px;
    margin: 10px auto 0;
}

.more-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px 12px;
    border-bottom: 0.5px solid #f3f4f6;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
}

.more-menu-header h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #111;
}

.close-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f3f4f6;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.close-btn:active {
    background: #e5e7eb;
}

.more-menu-content {
    padding: 6px 0 80px;
}

.more-menu-divider {
    font-size: 11px;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 14px 18px 6px;
}

.more-menu-item {
    display: flex;
    align-items: center;
    padding: 12px 18px;
    text-decoration: none;
    color: #111;
    border-bottom: 0.5px solid #f9fafb;
    -webkit-tap-highlight-color: transparent;
    gap: 12px;
}

.more-menu-item:active {
    background: #f9fafb;
}

.more-menu-item.active {
    background: #f5f3ff;
}

.more-menu-item.active .menu-title {
    color: #6366f1;
}

.menu-icon {
    width: 40px;
    height: 40px;
    background: #f3f4f6;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.more-menu-item.active .menu-icon {
    background: #ede9fe;
}

.menu-text {
    flex: 1;
    min-width: 0;
}

.menu-title {
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 1px;
}

.menu-subtitle {
    font-size: 12px;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.menu-chevron {
    color: #d1d5db;
    flex-shrink: 0;
}

/* ── NEW badge ── */
.icon-wrapper {
    position: relative;
    display: inline-flex;
}

.new-badge {
    position: absolute;
    top: -7px;
    right: -10px;
    background: #ef4444;
    color: white;
    font-size: 8px;
    font-weight: 700;
    padding: 1px 4px;
    border-radius: 6px;
    letter-spacing: 0.3px;
    animation: pulse-badge 2s infinite;
    cursor: default;
}

@keyframes pulse-badge {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
}

@media (min-width: 640px) {
    .bottom-nav-container { display: none; }
}

/* ── Footer Section ── */
.footer-section {
    margin: 12px 0 0;
    width: calc(100% + 30px);
}

.footer-section__help {
    background: #f0f4ff;
    border: 0.5px solid #c7d7fd;
    border-radius: 14px 14px 0 0;
    margin-bottom: 0;
    overflow: hidden;
    width: 100%;
}

.footer-section__help-title {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 13px 16px 11px;
    font-size: 14px;
    font-weight: 700;
    color: #1e3a8a;
    border-bottom: 0.5px solid #c7d7fd;
}

.footer-section__help-links {
    padding: 4px 0;
}

.footer-section__help-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    font-size: 13px;
    color: #1e40af;
    text-decoration: none;
    border-bottom: 0.5px solid #e8effe;
}

.footer-section__help-row:last-child {
    border-bottom: none;
}

.footer-section__help-row:active {
    background: #e0eaff;
}

.footer-section__help-row svg {
    flex-shrink: 0;
    color: #3b82f6;
}

/* ── Dark footer strip ── */
.footer-section__bottom {
    background: #1a1f2e;
    padding: 20px 16px 100px;
    text-align: center;
    border-radius: 0;
    margin-top: 0;
    width: 100%;
}

.footer-section__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    margin-bottom: 12px;
}

.footer-section__logo-name {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    letter-spacing: -0.2px;
    opacity: 0.9;
}

.footer-section__copy {
    font-size: 12px;
    color: #6b7280;
    margin: 0 0 10px;
}

.footer-section__links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
}

.footer-section__links a {
    font-size: 12px;
    color: #6b7280;
    text-decoration: none;
}

.footer-section__links a:hover {
    color: #9ca3af;
}

.footer-section__links span {
    color: #374151;
    font-size: 12px;
}
</style>